import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../../context/AuthContext";
import { LoadingButton } from "@mui/lab";
import { SnackAlertContext } from "../../../../../context/SnackAlertContext";

const AdminRequoteOrderDialog = ({ quoteId, open, onClose, onSuccess }) => {
  const { authToken, ezorder } = useContext(AuthContext);
  const { openSnackMessage } = useContext(SnackAlertContext);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [confirmText, setConfirmText] = useState(null);

  const handleClose = () => {
    // Reset and close
    setConfirmText("");
    setErrorMessage("");
    onClose();
  };

  const reQuoteOrder = async () => {
    try {
      setLoading(true);

      let formData = new FormData();
      formData.append("orderId", quoteId);
      formData.append("status", "REQUOTE_ORDER");
      const response = await ezorder.patch(
        `/admin/orders/${quoteId}/status`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "content-type": "multipart/form-data",
          },
        }
      );

      if (response.status == 200 || response.status == 201) {
        openSnackMessage("success", "Order reopened as Quote Draft");
        onSuccess();
        handleClose();
      } else {
        console.log(response);
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={() => {
        if (!loading) {
          handleClose();
        }
      }}
    >
      <DialogTitle>Re-Quote Order</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <DialogContentText>
          Before proceeding, please note that this will remove the signed quote
          and all quote approval data. It will also expire any existing Stripe
          payment links. Lastly, it will revert to a "Draft" status Quote
        </DialogContentText>
        <DialogContentText>
          Please confirm you want to Re-Quote this order by entering "requote"
        </DialogContentText>
        <TextField
          sx={{ marginTop: "16px" }}
          variant="outlined"
          label="requote"
          value={confirmText}
          onChange={(e) => {
            setConfirmText(e.target.value);
          }}
          size="large"
        />
      </DialogContent>
      <Box
        sx={{
          m: 1,
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {errorMessage && (
          <Box>
            <Typography color={"red"}>{errorMessage}</Typography>
          </Box>
        )}
      </Box>
      <DialogActions>
        <LoadingButton
          loading={loading}
          onClick={() => {
            if (!loading) handleClose();
          }}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          disabled={confirmText != "requote"}
          loading={loading}
          variant="contained"
          color="primary"
          onClick={() => {
            if (!loading) reQuoteOrder();
          }}
        >
          Approve
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default AdminRequoteOrderDialog;
